<template>
    <section class="py-16 lg:py-[150px] px-5 lg:px-[120px]" :style="sectionStyle">
        <!-- Header: Titel links, Icon rechts – auf Mobile gestapelt -->
        <div class="flex flex-col-reverse lg:flex-row lg:justify-between lg:items-start gap-6 mb-10 lg:mb-[50px]">
            <div class="flex-1">
                <h2 class="text-[28px] md:text-3xl lg:text-[44px] font-semibold leading-tight" :class="titleColor">
                    <span v-html="renderTitle()"></span>
                </h2>
                <p class="text-[20px] md:text-[20px] font-semibold mt-3 lg:mt-4 font-pro" :class="subtitleColor">
                    {{ subtitle }}
                </p>
            </div>
            <!-- Icon: auf Mobile kleiner, auf Desktop 114×114 -->
            <img v-if="iconImage" :src="iconImage" alt="Analyse Icon" class="w-16 h-16 lg:w-[114px] lg:h-[114px] object-contain flex-shrink-0 self-start" :class="iconColor" />
        </div>

        <!-- Cards: 1 Spalte Mobile → 2 Tablet → 3 Desktop, letzte Zeile zentriert -->
        <div class="flex flex-wrap justify-center gap-4 lg:gap-5">
            <div v-for="(pkg, index) in packages" :key="index" class="bg-white rounded-[20px] p-4 lg:p-5 shadow-sm w-full md:w-[386px] lg:w-[386px]">
                <!-- Bild + Name -->
                <div class="flex items-center gap-[10px] mb-4 lg:mb-5">
                    <img :src="pkg.image" :alt="pkg.name" class="w-14 h-14 lg:w-[70px] lg:h-[70px] object-contain flex-shrink-0" />
                    <h3 class="text-[20px] font-bold text-[#000000]">{{ pkg.name }}</h3>
                </div>

                <!-- Buttons -->
                <div class="flex items-center gap-[10px]">
                    <router-link
                        v-if="pkg.link"
                        :to="pkg.link"
                        class="flex-1 inline-flex items-center justify-center text-white text-sm lg:text-xl font-semibold py-[10px] px-3 lg:px-[10px] rounded-full hover:opacity-90 transition truncate"
                        :style="{ background: `linear-gradient(to bottom right, ${buttonGradientFrom}, ${buttonGradientTo})` }"
                    >
                        {{ pkg.buttonText || 'Auswählen' }}
                    </router-link>
                    <button
                        v-else
                        class="flex-1 inline-flex items-center justify-center text-white text-sm lg:text-xl font-semibold py-[10px] px-3 lg:px-[10px] rounded-full hover:opacity-90 transition truncate"
                        :style="{ background: `linear-gradient(to bottom right, ${buttonGradientFrom}, ${buttonGradientTo})` }"
                    >
                        {{ pkg.buttonText || 'Auswählen' }}
                    </button>

                    <!-- Info-Button: 44×44px – Figma -->
                    <PackageInfoButton v-if="pkg.infoText" :title="pkg.infoText" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import PackageInfoButton from './PackageInfoButton.vue';

const props = defineProps({
    backgroundColor: { type: String, default: 'linear-gradient(135deg, #0d9488 0%, #06b6d4 100%)' },
    title: { type: String, required: true },
    titleHighlight: { type: String, default: '' },
    titleHighlightColor: { type: String, default: 'text-white' },
    titleColor: { type: String, default: 'text-black' },
    subtitle: { type: String, default: '' },
    subtitleColor: { type: String, default: 'text-black' },
    packages: { type: Array, required: true },
    buttonGradientFrom: { type: String, default: '#0d9488' },
    buttonGradientTo: { type: String, default: '#06b6d4' },
    iconColor: { type: String, default: '' },
    iconImage: { type: String, default: '' }
});

const sectionStyle = computed(() => {
    const bg = props.backgroundColor;

    return bg.startsWith('linear-gradient') || bg.startsWith('radial-gradient') ? { background: bg } : { backgroundColor: bg };
});

const renderTitle = () => {
    if (!props.titleHighlight) return props.title;

    const parts = props.title.split(props.titleHighlight);

    if (parts.length === 1) return props.title;

    return parts.map((part, i) => (i === 0 ? part : `<span class="${props.titleHighlightColor}">${props.titleHighlight}</span>${part}`)).join('');
};
</script>
